import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

import translations from './ResetPasswordForm.translations'

export const ERROR_MESSAGES: Record<number, I18nDefinition> = {
  500: translations.error500,
  404: translations.error404,
}
